import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect, useState } from "react";
import "@/App.css";

import { StoreProvider, useStore } from "@/lib/store";
import api from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";
import CartDrawer from "@/components/CartDrawer";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import BankTransfer from "@/pages/BankTransfer";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import ShippingPolicy from "@/pages/ShippingPolicy";
import Admin from "@/pages/Admin";

function MaintenancePage() {
  return (
    <div className="min-h-screen bg-[#050806] text-[#F4F1ED] flex items-center justify-center px-6 text-center">
      <div className="max-w-xl">
        <div className="mx-auto mb-6 w-12 h-12 border border-[#C8A97E] flex items-center justify-center">
          <span className="font-serif text-[#C8A97E] text-2xl">K</span>
        </div>
        <h1 className="font-serif text-4xl mb-4">Kratoven is temporarily unavailable</h1>
        <p className="text-[#A8A5A1] leading-relaxed">
          We are updating the store right now. Please check back shortly.
        </p>
      </div>
    </div>
  );
}

function AppRoutes() {
  const location = useLocation();
  const { user } = useStore();
  const [settings, setSettings] = useState(null);

  const isAdmin = location.pathname.startsWith("/admin");
  const isAuthPage = ["/login", "/register", "/account"].includes(location.pathname);
  const isAdminUser = user?.role === "admin";

  useEffect(() => {
    api.get("/settings/public")
      .then((r) => setSettings(r.data))
      .catch(() => setSettings(null));
  }, []);

  const maintenanceOn = settings?.maintenance_mode === true;
  const blockPublic = maintenanceOn && !isAdmin && !isAuthPage && !isAdminUser;

  if (blockPublic) {
    return <MaintenancePage />;
  }

  return (
    <div className="App">
      {!isAdmin && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/bank" element={<BankTransfer />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/account" element={<Account />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/shipping" element={<ShippingPolicy />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={
          <div className="container-kv pt-32 pb-20 text-center">
            <h1 className="font-serif text-5xl mb-4">404</h1>
            <p className="text-[#A8A5A1]">Page not found.</p>
          </div>
        } />
      </Routes>

      {!isAdmin && <Footer />}
      {!isAdmin && <CartDrawer />}
      {!isAdmin && <FloatingContact />}

      <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#0D120E", border: "1px solid rgba(255,255,255,0.1)", color: "#F4F1ED" } }} />
    </div>
  );
}

export default function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </StoreProvider>
  );
}
